import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Logo } from "../components/Logo";
import MatrixBackground from "../components/MatrixBackground";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid-bg noise isolate flex items-center justify-center p-4" data-testid="reset-password-container">
      <MatrixBackground opacity={0.25} />
      <div className="w-full max-w-md glass rounded-3xl p-7 ring-cyan">
        <Logo size={34} />
        <h1 className="heading-font text-3xl font-extrabold mt-6">Set a new password</h1>
        {!token ? (
          <div className="mt-4 text-sm text-rose-300" data-testid="reset-password-invalid">
            This reset link is missing its token.{" "}
            <Link to="/forgot-password" className="text-cyan-300 underline">Request a new link</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4 mt-6" data-testid="reset-password-form">
            <div>
              <Label htmlFor="rp-pw" className="text-slate-300 text-xs uppercase tracking-widest font-bold">New password</Label>
              <Input id="rp-pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                className="mt-2 h-11 bg-white/5 border-cyan-500/15 text-white" placeholder="At least 8 characters" data-testid="reset-password-new" />
            </div>
            <div>
              <Label htmlFor="rp-pw2" className="text-slate-300 text-xs uppercase tracking-widest font-bold">Confirm password</Label>
              <Input id="rp-pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
                className="mt-2 h-11 bg-white/5 border-cyan-500/15 text-white" data-testid="reset-password-confirm" />
            </div>
            <Button type="submit" className="btn-neon w-full h-11 rounded-full" disabled={loading} data-testid="reset-password-submit">
              {loading ? "Saving…" : "Update password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
